<script>
export default {
  name: 'LoadingBoxes',
  props: {
    config: {
      type: Object,
      required: false,
    },
  },
};
</script>

<template>
  <div class="loading-boxes d-flex flex-column i-gap-4">
    <div
      v-for="item in config?.repeat || [0, 1, 2]"
      :key="item"
      class="empty-block d-flex i-gap-6 align-items-center"
    >
      <div
        v-if="!config || config?.showAvatar"
        class="avatar linear-background"
      ></div>
      <div class="lines d-flex flex-column i-gap-4">
        <div
          v-for="(length, index) in config?.lengths || [316, 263]"
          :key="index"
          :style="{ width: length + 'px' }"
          class="line d-flex linear-background"
        ></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loading-boxes {
  .empty-block {
    .avatar {
      min-width: 36px;
      height: 36px;
      border-radius: 100px;
      background-color: $light-neutral-30;
    }

    .lines {
      .line {
        height: 10px;
        background-color: $light-neutral-30;
        border-radius: 100px;
      }
    }
  }
}
</style>
